export default __webpack_public_path__ + "static/media/custom-content.372134c1.png";